import { Button } from '@mui/material';

import { ActionBar } from '@/components/Layout/Layout.styled';
import { QuestionProps } from '@/components/PageForm/MoreInfoForm/drawers/QuestionsDrawer/QuestionDrawer.interface';
import { QuestionForm } from '@/components/PageForm/MoreInfoForm/drawers/QuestionsDrawer/QuestionForm';

import { useQuestionInfoMutation } from '@/hooks/useQuestionInfoMutation';
import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

export function QuestionRenouncedUS({ onAnswered, ...props }: QuestionProps) {
  const { t } = useTranslate();
  const { mutate, isPending, error } = useQuestionInfoMutation({
    onFinished: onAnswered,
    target: props.pepAnswerTarget,
  });

  const onAnswer = (value: boolean) => {
    mutate({
      usCitizenshipRenouncement: value,
    });
  };

  const handleRenouncementYes = () => onAnswer(true);
  const handleRenouncementNo = () => onAnswer(false);

  return (
    <QuestionForm {...props} isLoading={isPending} answerError={error}>
      <ActionBar>
        <Button
          {...getDataTestId(`question-drawer-renouncement-us-yes-button`)}
          variant="outlined"
          fullWidth
          onClick={handleRenouncementYes}
          disabled={isPending}
        >
          {t('questionDrawer.RenouncementUS.button.yes')}
        </Button>
        <Button
          {...getDataTestId(`question-drawer-renouncement-us-no-button`)}
          variant="outlined"
          fullWidth
          onClick={handleRenouncementNo}
          disabled={isPending}
        >
          {t('questionDrawer.RenouncementUS.button.no')}
        </Button>
      </ActionBar>
    </QuestionForm>
  );
}
